module.exports = __webpack_public_path__ + "img/orange.161903bb.jpg";